import lazyLoading from './lazyLoading'

export default {
  name: 'Transactions',
  path: '/transactions',
  meta: {
    auth: true,
    icon: 'fa-money',
    link: 'transactions/index.vue'
  },
  component: lazyLoading('transactions', true)
  // children : []
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/transactions.js